import { z } from 'zod';
import { entityIdSchema, sha256Schema, utcDateTimeSchema } from '@kop/contracts';

/** Same 50 MiB per-original limit as the existing PDF document upload contract. */
export const TBM_SIGNATURE_PDF_MAX_BYTES = 50 * 1024 * 1024;
/** Matches the existing authenticated media delivery batch bound. */
export const TBM_SIGNATURE_PDF_MAX_FILES = 50;
export const tbmSignaturePdfSchema = z
  .object({
    manifestId: entityIdSchema,
    evidenceId: entityIdSchema,
    fileName: z
      .string()
      .trim()
      .min(1)
      .max(180)
      .refine(
        (value) =>
          /\.pdf$/iu.test(value) &&
          !/[\\/]/u.test(value) &&
          ![...value].some((character) => character.charCodeAt(0) < 32),
        'A PDF file name is required',
      ),
    mimeType: z.literal('application/pdf'),
    byteSize: z.number().int().positive().max(TBM_SIGNATURE_PDF_MAX_BYTES),
    sha256: sha256Schema,
    generation: z.string().regex(/^\d+$/u),
    committedAt: utcDateTimeSchema,
  })
  .strict();
export const tbmSignaturePdfsSchema = z
  .array(tbmSignaturePdfSchema)
  .max(TBM_SIGNATURE_PDF_MAX_FILES)
  .superRefine((references, ctx) => {
    if (
      new Set(references.map((reference) => reference.manifestId)).size !== references.length ||
      new Set(references.map((reference) => reference.evidenceId)).size !== references.length
    )
      ctx.addIssue({ code: 'custom', message: 'Signature document references must be unique' });
  });
export type TbmSignaturePdf = z.infer<typeof tbmSignaturePdfSchema>;
